export default "__VITE_ASSET__4HiBuXeS__"